<template>
  <div class="homePage">
    <Merchandise v-if="homeView === 'article'"></Merchandise>
    <EventListOrSingle v-else-if="homeView === 'ticket'" :isHome="true"></EventListOrSingle>
    <GuidedTours :isHome="true" v-else-if="homeView === 'tour'"></GuidedTours>
    <Vouchers :isHome="true" v-else-if="homeView === 'voucher'"></Vouchers>
    <Merchandise :isHome="true" kind="passes" v-else-if="homeView === 'memcard'"></Merchandise>
    <ProductCategoriesBig class="categoriesPage" v-else></ProductCategoriesBig>
    <teleport to="head">
      <component :is="'script'" type="application/ld+json">
        {{ jsonld }}
      </component>
    </teleport>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Merchandise from '../Merchandise/Merchandise.vue';
import ProductCategoriesBig from '../Products/ProductCategoriesBig.vue';
import GuidedTours from '../GuidedTours/GuidedToursList.vue';
import EventListOrSingle from '../Tickets/EventListOrSingle.vue';
import Vouchers from '../Vouchers/List.vue';

export default {
  name: 'HomeComponent',
  components: {
    Merchandise,
    ProductCategoriesBig,
    EventListOrSingle,
    GuidedTours,
    Vouchers,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      siteName: (state) => state.app.siteName,
      siteNameTranslations: (state) => state.app.siteNameTranslations,
      language: (state) => state.language,
      homeView: (state) => state.app.homeView,
    }),
    jsonld() {
      let siteName = this.siteName;
      if (typeof this.siteNameTranslations[this.language] != 'undefined') {
        siteName = this.siteNameTranslations[this.language];
      }
      return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteName,
        url: window.location.origin,
      };
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.homePage {
  margin-top: $sp * 2;
}
.categoriesPage {
  margin-top: $sp;
}
</style>
